import { render, staticRenderFns } from "./UploadFileIcon.vue?vue&type=template&id=03389c70&"
import script from "./UploadFileIcon.vue?vue&type=script&lang=js&"
export * from "./UploadFileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports